import React from "react";
import KaDialog from "../shared/KaDialog";
import Img from "../../assets/35.jpg";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import useScreensize from "../../hooks/useScreensize";

const useStyles = makeStyles(theme => ({
  imgBackground: {
    backgroundSize: "cover",
    backgroundPosition: "center center"
  },
  imgTag: {
    width: "100%",
    height: "auto",
    display: "block"
  },
  paragraph: {
    margin: theme.spacing(3, 0)
  }
}));

const KanzleiEngagament = ({ open, close }) => {
  const classes = useStyles();
  const { xs, sm, md, lg, xl } = useScreensize();
  const theme = useTheme();

  const mobile = xs || sm;

  return (
    <>
      <KaDialog open={open} close={close}>
        <>
          <Box
            display="flex"
            flexDirection={mobile ? "column" : "row"}
            p={{ sm: 3, md: 3 }}
            height={mobile ? undefined : 700}
          >
            {mobile ? (
              <Box
                bgcolor={theme.palette.primary.main}
                mb={3}
              >
                <img src={Img} alt="Engagement" className={classes.imgTag} />
              </Box>
            ) : (
              <Box
                p={3}
                className={classes.imgBackground}
                style={{ backgroundImage: "url(" + Img + ")" }}
                flexGrow={1}
                bgcolor={theme.palette.primary.main}
                flexShrink={1}
                flexBasis="0px"
                mr={3}
              ></Box>
            )}
            <Box
              color="white"
              p={{ xs: 3, sm: 4 }}
              flexGrow={1}
              bgcolor={theme.palette.primary.main}
              flexShrink={1}
              flexBasis={mobile ? "auto" : "0px"}
            >
              <Typography variant="h1" component="h2">
                Engagement
              </Typography>
              <Typography variant="h6" component="h3" gutterBottom>
                Unser Engagement für Ihren Erfolg
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Die komplexen und vielfältigen Herausforderungen einer
                umfassenden Beratung erfordern ein Höchstmaß an Vertrauen und
                Zuverlässigkeit.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Deshalb setzen wir den Fokus auf eine persönliche und
                partnerschaftliche Beziehung zu unseren Mandanten. Sie wissen
                wer bei uns Ihr Ansprechpartner ist.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Wenn wir Sie beraten, dann kennen wir Sie, Ihre Belange und
                Interessen. Wir gehen auf Ihre individuellen Anforderungen ein,
                denn bei uns wird Ihr Fall nicht nur verwaltet.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Wir möchten erfolgreich und langfristig mit Ihnen
                zusammenarbeiten
              </Typography>
            </Box>
          </Box>
        </>
      </KaDialog>
    </>
  );
};

export default KanzleiEngagament;
